export const PATHS = ["", "sale", "bermuda", "otc", "tortuga"];
